import {
  EVENT_LIST_REQUEST,
  EVENT_LIST_ERROR,
  EVENT_LIST
} from '../actions/types'

var initialState = {
  events: [],
  loading: false
}

export default function(state = initialState, action) {
  switch(action.type) {
    case EVENT_LIST_REQUEST:
      return {
        loading: action.payload.loading
      }
    case EVENT_LIST_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: action.payload.loading
      }
    case EVENT_LIST:
      return {
        ...state,
        events: action.payload.events,
        loading: action.payload.loading
      }
    default:
      return { ...state }
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/event_list_reducer.js
 **/